<template>
  <div class="skeleton" aria-hidden="true">
    <template v-if="type === 'table'">
      <div class="skeleton__row" v-for="n in rows" :key="'r' + n">
        <span class="skeleton__cell shimmer" v-for="c in 4" :key="'c' + c"></span>
      </div>
    </template>
    <template v-else-if="type === 'card'">
      <div
        class="skeleton__card shimmer"
        v-for="n in rows"
        :key="'k' + n"
      ></div>
    </template>
    <template v-else>
      <span
        class="skeleton__line shimmer"
        v-for="n in rows"
        :key="'l' + n"
        :style="{ height: height, width: n === rows ? '60%' : '100%' }"
      ></span>
    </template>
  </div>
</template>

<script>
// Placeholder de carregamento (skeleton) para regiões assíncronas.
// Use enquanto dados carregam, no lugar de spinner genérico.
export default {
  name: "SkeletonLoader",
  props: {
    rows: { type: Number, default: 3 },
    type: {
      type: String,
      default: "lines",
      validator: (v) => ["lines", "card", "table"].includes(v),
    },
    height: { type: String, default: "16px" },
  },
};
</script>

<style scoped>
.skeleton {
  width: 100%;
}
.shimmer {
  position: relative;
  overflow: hidden;
  background: var(--c-neutral-200);
  border-radius: var(--radius-sm);
}
.shimmer::after {
  content: "";
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transform: translateX(-100%);
  background: linear-gradient(
    90deg,
    transparent,
    rgba(255, 255, 255, 0.65),
    transparent
  );
  animation: skeleton-shimmer 1.4s infinite;
}
.skeleton__line {
  display: block;
  margin-bottom: var(--sp-3);
}
.skeleton__card {
  height: 96px;
  margin-bottom: var(--sp-3);
  border-radius: var(--radius-md);
}
.skeleton__row {
  display: flex;
  gap: var(--sp-3);
  margin-bottom: var(--sp-3);
}
.skeleton__cell {
  flex: 1;
  height: 20px;
}
@keyframes skeleton-shimmer {
  100% {
    transform: translateX(100%);
  }
}
@media (prefers-reduced-motion: reduce) {
  .shimmer::after {
    animation: none;
  }
}
</style>
